import api from './api';

export const documentService = {
  // Download document
  async downloadDocument(documentId: number, fileName: string): Promise<void> {
    try {
      const response = await api.get(`/api/documents/${documentId}/download`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Download failed');
    }
  },

  // Add document to favorites
  async addToFavorites(documentId: number): Promise<void> {
    try {
      console.log('Adding document to favorites', documentId);
      await api.post(`/api/users/favorites/${documentId}`);
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Failed to add to favorites');
    }
  },

  // Remove document from favorites
  async removeFromFavorites(documentId: number): Promise<void> {
    try {
      await api.delete(`/api/users/favorites/${documentId}`);
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Failed to remove from favorites');
    }
  },

  // Get user favorites
  async getFavorites(): Promise<any[]> {
    try {
      const response = await api.get('/api/users/favorites');
      return response.data.favorites || [];
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Failed to get favorites');
    }
  }
};
